<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import {
  required,
  minLength,
  numeric,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Airport Update",
      items: [
        {
          text: "Airport",
          href: "/",
        },
        {
          text: "Update",
          active: true,
        },
      ],
      id: "",
        airports:[],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
        lineError:true,
        form: {
            city: "",
            airportCode: "",
            airportName: "",
            countryCode: "",
            country: "",
            worldAreaCode: "",
        },
      submitform: false,
      submitted: false,
    };
  },
    validations: {
        form: {
            city: {
                required,
            },
            airportCode: {
                required,
            },
            airportName: {
                required,
            },
            countryCode: {
                required,
            },
            country: {
                required,
            },
            worldAreaCode: {
                required,
            },
        },
    },

  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.blockDetail();
  },
  methods: {
      onClose(){
          this.visible=false;
      },

    async blockDetail() {
      try {
        axios
          .post("/api/airport-detail/" + this.id, {
            accessToken: localStorage.getItem("access_tocken"),
          })
          .then((response) => {
            if (response.data.status) {
              var data = response.data.data;
                this.form.city=data.city,
                    this.form.airportCode=data.airportCode,
                    this.form.airportName=data.airportName
                this.form.countryCode=data.countryCode,
                    this.form.country=data.country,
                    this.form.worldAreaCode=data.worldAreaCode
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .put("/api/airport-update", {
            id:this.id,
            city:this.form.city,
            airportCode: this.form.airportCode,
            airportName: this.form.airportName,
            countryCode:this.form.countryCode,
            country: this.form.country,
            worldAreaCode: this.form.worldAreaCode,
            created_by: localStorage.getItem("uuid"),
            updated_by: localStorage.getItem("uuid"),
            accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.airportform.reset();
            this.$swal("Good job!", "Airport Updated", "success");
            this.$router.push({ name: "airport_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
    <Layout>
        <flashMessage/>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="errors" class="font-bold mb-4 ">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </div>
                        </div>
                        <b-form class="needs-validation" ref="airportform" @submit.prevent="formSubmit">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="city">City</label>
                                        <input
                                            id="city"
                                            v-model="form.city"
                                            name="city"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type city name"
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.city.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.city.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.city.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="airportCode">Airport Code </label>
                                        <input
                                            id="airportCode"
                                            v-model="form.airportCode"
                                            name="airportCode"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Airport Code"
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.airportCode.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.airportCode.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.airportCode.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="airportName">Airport Name</label>
                                        <input
                                            id="airportName"
                                            v-model="form.airportName"
                                            name="airportName"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Airport name"
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.airportName.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.airportName.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.airportName.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="countryCode">Country Code</label>
                                        <input
                                            id="countryCode"
                                            v-model="form.countryCode"
                                            name="countryCode"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Country Code"
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.countryCode.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.countryCode.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.countryCode.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="country">Country</label>
                                        <input
                                            id="country"
                                            v-model="form.country"
                                            name="country"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Country name"
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.country.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.country.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.country.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="worldAreaCode">World Area Code</label>
                                        <input
                                            id="worldAreaCode"
                                            v-model="form.worldAreaCode"
                                            name="worldAreaCode"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type World area code"
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.worldAreaCode.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.worldAreaCode.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.worldAreaCode.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-primary" type="submit">Submit</button>
                        </b-form>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>
